import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserProfileReporting } from '@liquitics/transaction/dist/lib/profiles';
import { PublishReportDashboardReportsRequest, PublishReportDashboardReportsResult, ReportDashboardConfig, ReportDashboardPersistedConfig, WebApiEndpoints } from '@liquitics/transaction/dist/lib/web-api';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppConfig } from '../../app.config';
import { AwsUtil } from '../../authentication/aws.service';
import { ReportDashboardTreeNode } from '../report-dashboard.component';

class PublishableReportDashboardConfigRow {
    config: ReportDashboardConfig;
    name: string;
    format: string;
    owner: string;
    publisher: string;
    recipients: string[];
    constructor(rdc: ReportDashboardConfig) {
        this.config = rdc;
        this.name = rdc.name;
        this.format = rdc.publishingConfig?.emailFormat || '?';
        this.owner = rdc.meta?.owner || '';
        this.publisher = rdc.meta?.publisher || '';
        this.recipients = rdc.publishingConfig?.emailRecipients || [];
    }
}


function formValidator(component: ReportDashboardPublishComponent) {
    return (formGroup: FormGroup) => {
        let returnValue = null;
        if (component.allowRecipientTypes) {
            if (component.recipientType.value === 'SPECIFIC') {
                if (!component.recipients.value || component.recipients.value.length === 0) {
                    return { recipients: true };
                }
            }
        }
        return returnValue;
    };
}

@Component({
    selector: 'app-report-dashboard-publish',
    templateUrl: './report-dashboard-publish.component.html',
    styleUrls: ['./report-dashboard-publish.component.scss']
})
export class ReportDashboardPublishComponent implements OnInit {
    public formGroup: FormGroup;

    publishDashboardColumns = [
        { field: 'name', header: 'Dashboard Name', width: '30%' },
        { field: 'format', header: 'Format', width: '10%' },
        { field: 'owner', header: 'Owner', width: '30%' },
        { field: 'publisher', header: 'Publisher', width: '30%' },
    ];

    @Input()
    isPreviewMode: boolean;
    @Input()
    designers: string[];
    @Input()
    reportDashboardNodes: ReportDashboardTreeNode[];
    @Input()
    batchIdentifier: string;

    @Input()
    reportDashboardIdentifier;
    @Input()
    previewIdentifier;

    @Input()
    allowRunTypes: boolean;
    @Input()
    allowRecipientTypes: boolean;



    isReportingAdmin: boolean;
    currentUser: string;

    constructor(
        private appConfig: AppConfig,
        private awsUtil: AwsUtil,
        private confirmationService: ConfirmationService,
        private messageService: MessageService
    ) {
        const reportingProfile: UserProfileReporting = this.appConfig.activeUserProfile as UserProfileReporting;
        this.isReportingAdmin = reportingProfile.isReportDashboardAdmin();
        this.currentUser = this.awsUtil.cognitoUtil.getCurrentUser().getUsername();
        this.formGroup = new FormGroup({
            recipientType: new FormControl('SPECIFIC'),
            recipients: new FormControl([]),
            runType: new FormControl('PREVIEW'),
            message: new FormControl(),
        }, formValidator(this));
    }

    get runType() { return this.formGroup.get('runType'); }
    get recipientType() { return this.formGroup.get('recipientType'); }
    get recipients() { return this.formGroup.get('recipients'); }

    ngOnInit() {
        if (!this.allowRunTypes) {
            this.runType.setValue('OFFICIAL');
        }
        if (!this.allowRecipientTypes) {
            this.recipientType.setValue('FROM_CONFIGURATION');
            this.recipients.setValue([]);
        }
    }
    onClearRecipients() {
        this.recipients.setValue([]);
    }

    onSend(event) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Proceed with publishing reports?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                let instructions;
                if (this.isPreviewMode) {
                    instructions = [
                        {
                            reportDashboardIdentifier: this.reportDashboardIdentifier,
                            emailRecipients: this.recipients.value,
                            outputIdentifier: this.previewIdentifier,
                        }
                    ]
                } else {
                    instructions = this.reportDashboardNodes
                        .filter((dashboardNode) => {
                            return dashboardNode.isMarked;
                        })
                        .map((dashboardNode) => {
                            return {
                                reportDashboardIdentifier: dashboardNode.data.identifier,
                                emailRecipients: this.recipients.value
                            }
                        });
                }
                const request = {
                    batchIdentifier: this.batchIdentifier,
                    instructions,
                } as PublishReportDashboardReportsRequest;
                this.awsUtil.webAPICall<PublishReportDashboardReportsResult>(WebApiEndpoints.PublishReportDashboardReports,
                    request, true)
                    .then((result: PublishReportDashboardReportsResult) => {
                        if (result.status === 'SUCCESS') {
                            this.messageService.add({ severity: 'info', summary: 'Success', detail: 'Successfully published reports.' });
                        } else {
                            this.messageService.add({ severity: 'error', summary: 'Failed to Publish', detail: result.message });
                        }
                    });
                // Unmark everything
                this.reportDashboardNodes
                    .forEach((dashboardNode) => {
                        dashboardNode.isMarked = false;
                    });
            },
            reject: () => {
            }
        });

    }
}
